module.exports = {
      id: "default-author-image-usage",
      viewBox: "0 0 48 48",
      url: "/" + "sprite-819208feb9a4c8de23db7726a2e05315.svg#default-author-image",
      toString: function () {
        return this.url;
      }
    }